import { Users } from "@just-in-types";
import { Reducer } from "redux";
import {
  ADD_VEHICLE,
  GET_HAS_USER_PAID_TODAY,
  GET_LOYALTY_CYCLE_TEXT,
  GET_USER,
  GET_USER_REWARD_TEXT,
  REMOVE_VEHICLE,
  RESET,
  SET_USER_OPTED_OUT,
  SET_USER_VALUE,
  SKIP_CHECK_IN,
  UserValue,
} from "../actions";

export type UserState = Users.User | Users.UserWithAccount;

const userInitialState: UserState = {
  dateofbirth: null,
  email: null,
  hasAccount: false,
  hasPaidToday: false,
  language: "eng",
  loyaltyCycleText: null,
  mobile: null,
  mugshot: null,
  mugshotUrl: null,
  name: { displayName: null, firstname: null, lastname: null },
  receiptCode: null,
  secretMobile: null,
  signature: null,
  signatureUrl: null,
  skipCheckIn: false,
  userId: "",
  userRewardText: null,
  vehicles: [],
  waiver: null,
  zip: null,
};

const userReducer: Reducer<UserState> = (
  state = userInitialState,
  { type, payload }
): UserState => {
  switch (type) {
    case ADD_VEHICLE: {
      const vehicles = state.vehicles ? [...state.vehicles] : [];

      if (
        vehicles.some(
          ({ make, model, yearMax, yearMin }) =>
            make === payload.make &&
            model === payload.model &&
            yearMax === payload.yearMax &&
            yearMin === payload.yearMin
        )
      ) {
        return state;
      } else {
        return { ...state, vehicles: [...vehicles, payload] };
      }
    }

    case REMOVE_VEHICLE: {
      const { make, model, yearMax, yearMin } = payload;
      const nextVehicles = state.vehicles.filter(
        (vehicle: Users.VehiclePick) =>
          make !== vehicle.make ||
          model !== vehicle.model ||
          yearMax !== vehicle.yearMax ||
          yearMin !== vehicle.yearMin
      );

      return {
        ...state,
        vehicles: nextVehicles,
      };
    }
    case SET_USER_OPTED_OUT:
      return { ...state, ...payload };
    case SET_USER_VALUE: {
      const { name, value } = payload as UserValue;
      state[name] = value;
      console.log(state);

      return state;
    }

    case RESET:
      return userInitialState;

    case GET_USER:
      return { ...state, ...payload };

    case GET_HAS_USER_PAID_TODAY:
      return { ...state, hasPaidToday: payload };

    case GET_LOYALTY_CYCLE_TEXT:
      return { ...state, loyaltyCycleText: payload };

    case GET_USER_REWARD_TEXT:
      return { ...state, userRewardText: payload };

    case SKIP_CHECK_IN:
      return { ...state, skipCheckIn: payload };

    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.ts